import { redirect } from 'saddlebag-browser';

export const handleAndThrowForBotTraffic = (error: { redirect_to: string }) => {
  if (!error.redirect_to) {
    return;
  }
  const { redirect_to: redirectTo } = error;

  redirect(redirectTo);

  throw error;
};
